export class SearchParamsModel {
  constructor(
    public pCode = '',
    public itemCode = '',
    public janCode = '',
    public makerName = '',
    public tagSearchType = '',
    public goodsMarkSearch = '',
    public dataKbnFlg = false,
    public goodsDiv = '',
    public buyerCode = '',
    public admitStatus = '',
    public registDateFrom = '',
    public registDateTo = '',
    public updateDateFrom = '',
    public updateDateTo = '',
    public classCode = '',
    public middleClassCode = '',
    public smallClassCode = '',
    public orderClientCode = '',
    public orderClientKanji = '',
    public payeeClientCode = '',
    public payeeClientKanji = '',
    public tagIdList = [],
    public goodsMarkList = [],
    public coopCodeList = [],
    public pCodeList = [],
    public itemCodeList = [],
    public duties = [],
    public guideGoodsNames = [],
    public guideStandardNames = [],
  ) { }
}